import { INITIAL_STATE, updateUi} from '../core'
import {
    SET_UI_PW_MODAL_OPEN,
    SET_PAYMENT_MODAL_OPEN,
    SET_SELECTED_SIDEBAR_TAB,
    SET_SELECTED_ADMIN_TAB,
    SET_IS_LOADING,
    SET_SELECTED_SETTINGS_TAB,
    SET_UI,
    SET_UI_NOTIFICATION_PREFERENCES,
} from '../action_creators'

function ui(state=INITIAL_STATE.ui, action) {
    switch (action.type) {
        case SET_UI: 
            return action.ui
        case  SET_UI_PW_MODAL_OPEN:
            return updateUi(state, 'pwModalOpen', action.pwModalOpen)
        case SET_PAYMENT_MODAL_OPEN:
            return updateUi(state, 'paymentModalOpen', action.paymentModalOpen)
        case SET_SELECTED_SIDEBAR_TAB:
            return updateUi(state, 'selectedSidebarTab', action.selectedSidebarTab)
        case SET_SELECTED_ADMIN_TAB:
            return updateUi(state, 'selectedAdminTab', action.selectedAdminTab)
        case SET_IS_LOADING:
            return updateUi(state, 'isLoading', action.isLoading)
        case SET_SELECTED_SETTINGS_TAB:
            return updateUi(state, 'selectedSettingsTab', action.selectedSettingsTab)
        case SET_UI_NOTIFICATION_PREFERENCES:
            return updateUi(state, 'notificationPreferences', action.notificationPreferences)
        default:
            return state
    }
}

export default ui


// WEBPACK FOOTER //
// ./src/redux/reducers/ui_reducer.js